import { render } from "./employee-detail.vue?vue&type=template&id=7eb85ff4&scoped=true"
import script from "./employee-detail.vue?vue&type=script&lang=js"
export * from "./employee-detail.vue?vue&type=script&lang=js"

import "./employee-detail.vue?vue&type=style&index=0&id=7eb85ff4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eb85ff4"]])

export default __exports__